import { Link, Outlet } from "react-router-dom";
import { getActiveAccount, logout } from "../auth/msal";

export function Layout() {
  const account = getActiveAccount();
  const initial = (account?.name ?? account?.username ?? "?").charAt(0).toUpperCase();

  return (
    <div className="layout">
      <header className="app-header">
        <div className="app-header__inner">
          <Link to="/" className="brand" aria-label="Consensi — Amministrazione">
            <span className="brand__mark" aria-hidden="true">A</span>
            Consensi — Amministrazione
          </Link>
          <div className="app-header__spacer" />
          {account ? (
            <div className="app-header__user">
              <span className="avatar" aria-hidden="true">{initial}</span>
              <span className="sr-only">{account.name ?? account.username}</span>
              <button
                type="button"
                className="btn btn--ghost"
                onClick={() => void logout()}
              >
                Esci
              </button>
            </div>
          ) : null}
        </div>
      </header>

      <main className="main">
        <Outlet />
      </main>

      <footer className="app-footer">
        <span>© {new Date().getFullYear()} AutoConnexa</span>
        <span aria-hidden="true"> · </span>
        <span>Identity &amp; Access via SSO centralizzato</span>
      </footer>
    </div>
  );
}
